// extracted by mini-css-extract-plugin
export default {"headContent":"ScreensSwitcher_headContent__GYy-P","screen":"ScreensSwitcher_screen__ri2dv","screenActive":"ScreensSwitcher_screenActive__GzdwN"};